/**
 * AI Chatbot Iframe Constants
 *
 * Constants used for AI Chatbot iframe loading, error handling, and timeout management.
 */

// Default timeout for iframe load detection (30 seconds)
// This timeout is used to detect when an iframe fails to load its content.
// For cross-origin iframes, this is the primary error detection mechanism.
export const IFRAME_LOAD_TIMEOUT_MS = 30000

// Query parameter name used to force iframe reload
// When refresh is triggered, this parameter is appended to the URL with a timestamp
// to ensure the iframe reloads even if the src URL hasn't changed
export const IFRAME_RELOAD_QUERY_PARAM = '_reload'

// Error types for iframe loading failures
export const IFRAME_ERROR_TYPES = Object.freeze({
  TIMEOUT: 'timeout', // Iframe didn't load within timeout period
  BLOCKED: 'blocked', // Iframe appears blocked (e.g., X-Frame-Options)
  ERROR: 'error', // Native @error event fired (e.g., DNS failure, 404, network error)
})
